import '../index.css';
import Button from 'react-bootstrap/esm/Button';
import FormGroup from 'react-bootstrap/esm/FormGroup';
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


function ContactForm() {
    return (
        
        <Form action='send_email.php' method='POST' id='formId'>

            <Form.Group className="mb-3" controlId="formBasicName">
                <FloatingLabel
                    label="Name"
                >
                    <Form.Control required type="text" id='fullname' name='fullname' placeholder="Enter name" />
                </FloatingLabel>
            </Form.Group>



            <Form.Group className="mb-3" controlId="formBasicEmail">
            <FloatingLabel
                controlId="floatingInput"
                label="Email address"    
            >
            <Form.Control required type="email" id='email' name='email' placeholder="Enter email"  />
            </FloatingLabel>
            
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPhone">
                <FloatingLabel
                    label="Phone Number"
                >

                <Form.Control type="tel" id='phonenumber' name='phonenumber' placeholder="Phone Number" pattern='[0-9]{3}[0-9]{3}[0-9]{4}' />
                </FloatingLabel>
                
            </Form.Group>

            <Row>
                <Col>
                    <FormGroup className="mb-3">
                        <FloatingLabel
                            label="Age"
                        >
                            <Form.Control required type='number' id='age' name='age' placeholder='Age'/>
                        </FloatingLabel>
                
                
                    </FormGroup>
                </Col>
                <Col>
                    <Form.Group className="mb-3" controlId="formBasicSelecy">
                        <FloatingLabel
                            label="Gender"
                        >
                            <Form.Select id='gender' name='gender' >
                                <option>Choose</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>


                
                
            <Row>
                <Col>
                    <Form.Group className="mb-3">
                        <FloatingLabel
                            label="Height (Feet)"
                        >     
                                    <Form.Select id='ft' name='ft' >
                                        <option value={"4ft"}>4ft</option>
                                        <option value={"5ft"}>5ft</option>
                                        <option value={"6ft"}>6ft</option>
                                    </Form.Select>                              
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3">
                        <FloatingLabel
                            label="Height (Inches)"
                        >     
                                    <Form.Select id='in' name='in'>
                                        <option value={"0in"}>0in</option>
                                        <option value={"1in"}>1in</option>
                                        <option value={"2in"}>2in</option>
                                        <option value={"3in"}>3in</option>
                                        <option value={"4in"}>4in</option>
                                        <option value={"5in"}>5in</option>
                                        <option value={"6in"}>6in</option>
                                        <option value={"7in"}>7in</option>
                                        <option value={"8in"}>8in</option>
                                        <option value={"9in"}>9in</option>
                                        <option value={"10in"}>10in</option>
                                        <option value={"11in"}>11in</option>
                                        
                                    </Form.Select>                              
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>

                    <Form.Group className="mb-3">
                        <FloatingLabel
                            label="Weight (lbs)"
                        >
                            <Form.Control id='weight' name='weight' placeholder='Weight' type='number'/>
                        </FloatingLabel>
                    </Form.Group>
            






            <Form.Group className="mb-3">
                <FloatingLabel
                    label="How long have you been training?"
                >
                    <Form.Control type='text' id='trainingyrs' name='trainingyrs' required placeholder='How long have you been training?'/>
                </FloatingLabel>
                
                
            </Form.Group>


            <Form.Group className="mb-3">
                <FloatingLabel
                    label="Why did you decide to start training?"
                >
                <Form.Control required as="textarea" id='whystart' name='whystart' placeholder='Why did you decide to start training' style={{height: '100px'}}/>

                </FloatingLabel>
            </Form.Group>


            <Form.Group className="mb-3">
                <FloatingLabel
                    label='Do you want to hire a coach long term?'
                >
                    <Form.Select id='hirecoach' name='hirecoach'>
                        <option value={"Yes"}>Yes</option>
                        <option value={"No"}>No</option>
                    </Form.Select>
                </FloatingLabel>
                
                
            </Form.Group>


            <Form.Group className="mb-3">
                <FloatingLabel
                    label='What are your fitness goals?'
                >

                    <Form.Control required as="textarea" id='goals' name='goals' placeholder='What are your fitness goals?' style={{height: '100px'}}/>
                </FloatingLabel>
                
            </Form.Group>


            <Button id='submit' name='submit' variant="danger" type="submit">
                Submit
            </Button>
        </Form>
        
        

    );
}

export default ContactForm;